import constants from '../constants';

const getGlobalsFromHTML = (html) => [
  ...new Set(html.match(constants.regularExpressions.WS_GLOBAL_ALL)),
];

export default getGlobalsFromHTML;
